import { createGlobalStyle } from 'styled-components';
import { deepTone, withAlpha, surfacePalette, readableOnWhite } from '../components/Helper/helper';

// brand colour used for accents on white cards; darkened only if too light to see on white
const brand = (theme) => readableOnWhite(theme.colors.primary);

const surface = (theme) => surfacePalette({
  background: theme.colors.background,
  foreground: theme.colors.text && theme.colors.text.foreground,
  primary: theme.colors.primary,
});

export const GlobalStyles = createGlobalStyle`
 /*-----------------------------------
    1. Body / Typography 
  -----------------------------------*/

  a:focus, a:hover {
    color: ${({ theme }) => brand(theme)};
  }

 h1.page-title {
   color: ${({ theme }) => theme.colors.text.primary};
 }

 h1.page-title:before, h1.page-title:after {
    background-color: ${({ theme }) => theme.colors.text.primary};
  }

  h1:before, h1:after {
    background-color: ${({ theme }) => brand(theme)};
  }

  h2:after, h2:before {
    border-bottom: 1px solid ${({ theme }) => brand(theme)};
    border-top: 1px solid ${({ theme }) => brand(theme)};
  }

  /*-----------------------------------
  3. Buttons 
  -----------------------------------*/  

  .btn-default {
    background-color: ${({ theme }) => brand(theme)};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  .btn-default:hover, .btn-default:focus {
    background-color:  ${({ theme }) => theme.colors.primary_highlight};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  .btn-primary {
    background-color: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  .btn-primary:hover {
    background-color: ${({ theme }) => theme.colors.secondary_highlight};
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  .btn-link {
    color: ${({ theme }) => theme.colors.secondary};
    border-bottom: 2px solid ${({ theme }) => theme.colors.secondary};
  }

  .btn-link:hover {
    color: ${({ theme }) => theme.colors.secondary_highlight};
    border-bottom: 2px solid ${({ theme }) => theme.colors.secondary_highlight};
  }

    /*-------------------------
  4.5  Feature Block
  --------------------------*/

  /*-------------------------
  9.2  Service / single / sidebar
  --------------------------*/

  .service-block:hover {
    border-color: ${({ theme }) => brand(theme)};
  }

  .service-icon {
    color: ${({ theme }) => brand(theme)};
  }



  .cta-section {
    background: ${({ theme }) => theme.colors.primary_highlight};
    background: -moz-linear-gradient(103deg, ${({ theme }) => theme.colors.primary_highlight} 16%, ${({ theme }) => theme.colors.primary_shade}; 100%);
    background: -webkit-linear-gradient(103deg, ${({ theme }) => theme.colors.primary_highlight} 16%, ${({ theme }) => theme.colors.primary_shade} 100%);
    background: linear-gradient(103deg, ${({ theme }) => theme.colors.primary_highlight} 16%, ${({ theme }) => theme.colors.primary_shade} 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="${({ theme }) => theme.colors.primary_highlight}",endColorstr="${({ theme }) => theme.colors.primary_shade}",GradientType=1);
  }

  .cta-section h3, .cta-section p {
    color: ${({ theme }) => theme.colors.text.primary};
    font-family: 'Rubik', sans-serif;
  }

  .holiday-notice {
    color: ${({ theme }) => brand(theme)};
    font-weight: 400;
  }

  .st-pagination .pagination>li>a:focus,
  .st-pagination .pagination>li>a:hover,
  .st-pagination .pagination>li>span:focus,
  .st-pagination .pagination>li>span:hover {
    background-color: ${({ theme }) => brand(theme)};
    border: ${({ theme }) => brand(theme)} 1px solid;
  }

  .st-pagination .pagination>.active>a,
  .st-pagination .pagination>.active>a:focus,
  .st-pagination .pagination>.active>a:hover,
  .st-pagination .pagination>.active>span,
  .st-pagination .pagination>.active>span:focus,
  .st-pagination .pagination>.active>span:hover {
    background-color: ${({ theme }) => brand(theme)};
    border: 1px solid ${({ theme }) => brand(theme)};
  }


/*--------------
5.4 Page Header
--------------*/

.page-header {
background: ${({ theme }) => theme.colors.primary_highlight};
background: -moz-linear-gradient(103deg, ${({ theme }) => theme.colors.primary_highlight} 16%, ${({ theme }) => theme.colors.primary_shade}; 100%);
background: -webkit-linear-gradient(103deg, ${({ theme }) => theme.colors.primary_highlight} 16%, ${({ theme }) => theme.colors.primary_shade} 100%);
background: linear-gradient(103deg, ${({ theme }) => theme.colors.primary_highlight} 16%, ${({ theme }) => theme.colors.primary_shade} 100%);
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="${({ theme }) => theme.colors.primary_highlight}",endColorstr="${({ theme }) => theme.colors.primary_shade}",GradientType=1);
}

  /*-----------------------------------
    6. Slider 
  -------------------------------------*/
  .slider .owl-nav .owl-prev:hover {background-color: ${({ theme }) => brand(theme)};
    border: 2px solid ${({ theme }) => brand(theme)}; text-decoration: none; color: ${({ theme }) => theme.colors.text.primary};}

  .slider .owl-nav .owl-next:hover { background-color: ${({ theme }) => brand(theme)};
    border: 2px solid ${({ theme }) => brand(theme)}; text-decoration: none; color: ${({ theme }) => theme.colors.text.primary}; }

  .slider .owl-dots .owl-dot.active span,
  .owl-theme .owl-dots .owl-dot:hover span {
    background-color: ${({ theme }) => brand(theme)};
    border: 2px solid ${({ theme }) => brand(theme)};
  }

  /*-----------------------------------
  8. Footer
  -------------------------------------*/
  /* footer & header: background configured per clinic (to suit the logo); text adapts to stay readable */
  .footer, .header-wrapper {
    --surface-bg: ${({ theme }) => surface(theme).bg};
    --surface-text: ${({ theme }) => surface(theme).text};
    --surface-heading: ${({ theme }) => surface(theme).heading};
    --surface-muted: ${({ theme }) => surface(theme).muted};
    --surface-accent: ${({ theme }) => surface(theme).accent};
    --surface-tint: ${({ theme }) => surface(theme).tint};
    --surface-border: ${({ theme }) => surface(theme).border};
  }

  .about-list ul li:before {
    color: ${({ theme }) => brand(theme)};
  }

  .sticky-cta {
    --cta-primary: ${({ theme }) => brand(theme)};
  }

  .top-bar, .tiny-footer, .page-hero, .mobile-menu {
    --band-bg: ${({ theme }) => deepTone(theme.colors.primary_shade)};
    --band-bg-2: ${({ theme }) => deepTone(theme.colors.primary_shade, 0.12)};
    --band-accent: ${({ theme }) => theme.colors.primary_shade};
  }

  :root {
    --brand-primary: ${({ theme }) => brand(theme)};
    --brand-primary-dark: ${({ theme }) => deepTone(brand(theme))};
    --brand-highlight: ${({ theme }) => withAlpha(brand(theme), 0.22)};
    --brand-tint-soft: ${({ theme }) => withAlpha(brand(theme), 0.06)};
    --brand-tint: ${({ theme }) => withAlpha(brand(theme), 0.10)};
    --brand-tint-strong: ${({ theme }) => withAlpha(brand(theme), 0.16)};
  }
`;
